import { Record } from 'immutable';

import BaseVehicle from './BaseVehicle.js';
import EnhancedPricing from './EnhancedPricing';
import Price from './Price';

const InventoryVehicleRecord = Record({
    ...BaseVehicle,
    price: new Price(),
    enhancedPricing: new EnhancedPricing(),
    organizationUnitName: '',
    stockNumber: '',
    photos: [],
    isLocked: false,
    motor: {
        driveTrain: '',
        engine: '',
        transmission: '',
    },
    flags: [],
    trim: '',
    modelTrim: '',
});

class InventoryVehicle extends InventoryVehicleRecord {}

export default InventoryVehicle;



// WEBPACK FOOTER //
// ./src/models/InventoryVehicle.js